import React from 'react';
import Icon from '../common/Icon/Icon';
import frontExampleImage from '../../assets/images/photo_guidelines/front.jpeg';
import styles from './PhotoExampleComparison.module.css';

const PhotoExampleComparison: React.FC = () => (
  <div className={styles.examplesContainer}>
    <div className={styles.exampleImageWrapper}>
      <div className={styles.imageWithIconWrapper}>
        <div className={styles.imageContainer}>
          <img
            src={frontExampleImage}
            alt="Exemplo incorreto de enquadramento"
            className={`${styles.exampleImage} ${styles.zoomedImage2}`}
          />
        </div>
        <span className={`${styles.iconOverlay} ${styles.incorrectIconBg}`} aria-hidden="true">
          <Icon name="cancel" size={28} />
        </span>
      </div>
    </div>

    <div className={styles.exampleImageWrapper}>
      <div className={styles.imageWithIconWrapper}>
        <div className={styles.imageContainer}>
          <img
            src={frontExampleImage}
            alt="Exemplo correto de enquadramento"
            className={`${styles.exampleImage} ${styles.correctZoom}`}
          />
        </div>
        <span className={`${styles.iconOverlay} ${styles.correctIconBg}`} aria-hidden="true">
          <Icon name="check_circle" size={28} />
        </span>
      </div>
    </div>
  </div>
);

export default PhotoExampleComparison;
